export default "__VITE_ASSET__1da080f5__"